import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const ListCoRoleName = createAsyncThunk(
  'co-users/listByRoleId',
  async ({ name, group_id }, { getState, rejectWithValue }) => {
    const { loginToken } = getState();
    const authToken = loginToken?.response?.token;
    try {
      const params = new URLSearchParams();
      if (group_id) params.set('group_id', String(group_id));
      const query = params.toString();
      const response = await fetch(
        `${ROOT_URL}/co-users/listByRoleId/${name}${query ? `?${query}` : ''}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      const result = await response.json();
      return result;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const ListCoUserRole = createSlice(
  {
    name: 'deleteGroup',
    initialState,
    reducers: {},
    extraReducers: {
      [ListCoRoleName.pending]: (state) => {
        state.isLoading = true;
      },
      [ListCoRoleName.fulfilled]: (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.response = action.payload;
      },
      [ListCoRoleName.rejected]: (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.error = action.payload;
      },
    },
  },
);

export default ListCoUserRole;
